// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__csJZ0","transparent-mode":"Header_transparent-mode__p3gq1","app-header":"Header_app-header__l8aIu"};